import $ from 'jquery';
import config from '../../../config';

// Get Employee
export function get_employee( id ){
	return dispatch => {

		$.ajax({
			method: 'GET',
			url: config.apiurl + 'employee.edit/',
			data: {
                method: 'GET_EMPLOYEE_EDIT',
                user_id: id
            }
		})
		.then(function (response) {
			dispatch({
				type: "GET_EMPLOYEE_EDIT",
				employeeedit: response
			})
		})

	}
}

// Get Employee
export function update_employee( id, data ){
	return dispatch => {

		$.ajax({
			method: 'POST',
			url: config.apiurl + 'employee.edit/',
			data: {
                method: 'UPDATE_EMPLOYEE_EDIT',
				user_id: id,
				data: data
            }
		})
		.then(function (response) {
			dispatch({
				type: "UPDATE_EMPLOYEE_EDIT",
				employeeedit: response
			})
		})

	}
}

// Get Department
export function get_department(){
	return dispatch => {

		$.ajax({
			method: 'GET',
			url: config.apiurl + 'employee.edit/',
			data: {
                method: 'GET_DEPARTMENT_EDIT',
            }
		})
		.then(function (response) {
			dispatch({
				type: "GET_DEPARTMENT_EDIT",
				employeeedit: response
			})
		})

	}
}


// Get all Employee
export function get_employee_list(){
	return dispatch => {

		$.ajax({
			method: 'GET',
			url: config.apiurl + 'employee.edit/',
			data: {
                method: 'GET_EMPLOYEE_LIST_EDIT',
            }
		})
		.then(function (response) {
			dispatch({
				type: "GET_EMPLOYEE_LIST_EDIT",
				employeeedit: response
			})
		})

	}
}

// Get Designation
export function get_designation(){
	return dispatch => {

		$.ajax({
			method: 'GET',
			url: config.apiurl + 'employee.edit/',
			data: {
                method: 'GET_DESIGNATION_EDIT',
            }
		})
		.then(function (response) {
			dispatch({
				type: "GET_DESIGNATION_EDIT",
				employeeedit: response
			})
		})

	}
}


// Get Company
export function get_company(){
	return dispatch => {

		$.ajax({
			method: 'GET',
			url: config.apiurl + 'employee.edit/',
			data: {
                method: 'GET_COMPANY_EDIT',
            }
		})
		.then(function (response) {
			dispatch({
				type: "GET_COMPANY_EDIT",
				employeeedit: response
			})
		})

	}
}

// Upload Profile Pic

export function upload_files( data ){
	return dispatch => {
		
		$.ajax({
			method: 'POST',
			dataType : 'json',
			url: config.apiurl + 'employee.edit/',
			data: data,
			processData: false,
			contentType: false
		}).then(function ( response ) {
			dispatch({
				type: "UPLOADED_PROFILE_PIC",
				employeeedit: response
			})
		})

	}

}

export function upload_documents( data ){
	return dispatch => {
		
		$.ajax({
			method: 'POST',
			dataType : 'json',
			url: config.apiurl + 'documents/',
			data: data,
			processData: false,
			contentType: false
		}).then(function ( response ) {
			dispatch({
				type: "UPLOADED_DOCUMENT",
				employeeedit: response
			})
		})

	}

}

export function delete_documents( id ){
	return dispatch => {
		
		$.ajax({
			method: 'GET',
			dataType : 'json',
			url: config.apiurl + 'documents/',
			data: {
				method: 'DELETE_DOCUMENT',
				document_id: id
            }
		}).then(function ( response ) {
			dispatch({
				type: "DELETE_DOCUMENT",
				employeeedit: response
			})
		})

	}

}

export function get_assets( id ){
	return dispatch => {
		
		$.ajax({
			method: 'GET',
			dataType : 'json',
			url: config.apiurl + 'assets/',
			data: {
				method: 'GET_ASSETS',
            }
		}).then(function ( response ) {
			dispatch({
				type: "GET_EMPLOYEE_ASSETS",
				employeeedit: response
			})
		})

	}

}


export function save_asset_log( data ){
	return dispatch => {
		
		$.ajax({
			method: 'GET',
			dataType : 'json',
			url: config.apiurl + 'employee.edit/',
			data: {
				method: 'SAVE_ASSET_LOG',
				data: data
            }
		}).then(function ( response ) {
			dispatch({
				type: "SAVE_ASSET_LOG",
				employeeedit: response
			})
		})

	}

}

export function delete_asset_log( id ){
	return dispatch => {
		
		$.ajax({
			method: 'GET',
			dataType : 'json',
			url: config.apiurl + 'employee.edit/',
			data: {
				method: 'DELETE_ASSET_LOG',
				log_id: id
            }
		}).then(function ( response ) {
			dispatch({
				type: "DELETE_ASSET_LOG",
				employeeedit: response
			})
		})

	}

}

export function set_date_return_asset_log( id, date ){
	return dispatch => {
		
		$.ajax({
			method: 'GET',
			dataType : 'json',
			url: config.apiurl + 'employee.edit/',
			data: {
				method: 'SET_RT_DATE_ASSET_LOG',
				log_id: id,
				date: date
            }
		}).then(function ( response ) {
			dispatch({
				type: "SET_RT_DATE_ASSET_LOG",
				employeeedit: response
			})
		})

	}

}

export function set_date_given_asset_log( id, date ){
	return dispatch => {
		
		$.ajax({
			method: 'GET',
			dataType : 'json',
			url: config.apiurl + 'employee.edit/',
			data: {
				method: 'SET_GN_DATE_ASSET_LOG',
				log_id: id,
				date: date
            }
		}).then(function ( response ) {
			dispatch({
				type: "SET_GN_DATE_ASSET_LOG",
				employeeedit: response
			})
		})

	}

}

export function set_log_notes( id, notes ){
	return dispatch => {
		
		$.ajax({
			method: 'GET',
			dataType : 'json',
			url: config.apiurl + 'employee.edit/',
			data: {
				method: 'SET_LOG_NOTES',
				log_id: id,
				notes: notes
            }
		}).then(function ( response ) {
			dispatch({
				type: "SET_LOG_NOTES",
				employeeedit: response
			})
		})

	}

}


// WEBPACK FOOTER //
// ./src/pages/employee.edit/actions/employee.edit.action.js